export const ModifyContactModal: string = 'ModifyContactModal';
